module.exports = __webpack_public_path__ + "media/images/athletes/2491-a16d5fc633ca0116e39dcb0a6df44700.png";